export default __webpack_public_path__ + "static/media/overdenture-3597628_1920.74fce1ab.jpg";